// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Xcj-","productName":"Table_productName__2ah6y"};